import { useEffect, useState } from "react";
export const useLocalStorage = (storageId, defaultValue, useType) => {
    var _a;
    function convert(v) {
        if (useType === "number") {
            return Number(v);
        }
        return v;
    }
    const [v, setV] = useState((_a = convert(localStorage.getItem(storageId))) !== null && _a !== void 0 ? _a : defaultValue);
    useEffect(() => {
        if (!localStorage.getItem(storageId)) {
            localStorage.setItem(storageId, String(defaultValue));
            setV(defaultValue);
        }
    }, []);
    useEffect(() => {
        localStorage.setItem(storageId, String(v));
    }, [v]);
    return [v, setV];
};
